import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import React, { useState } from "react";
import CardSolicitarSaque from "./CardSolicitarsaque";
import "./PedidoSaque.css";

const PedidoSaque = () => {
  const [menuClose, setMenuClose] = useState(false);
  const toggleMenu = () => setMenuClose((prev) => !prev);

  return (
    <div className="app-container">
      <Sidebar close={menuClose} />

      <main className="main-content">
        <Topbar page="Dashboard / Solicitar saque" onToggleMenu={toggleMenu} />

        <CardSolicitarSaque />
      </main>
    </div>
  );
};

export default PedidoSaque;
